export default __webpack_public_path__ + "static/media/Iconly-Bold-Graph.ce43c40d.svg";